import { Stack, Typography, useTheme } from '@mui/material';
import React, { memo } from 'react';
import ja from 'utils/ja';

const formatNumber = (number: number) => number.toLocaleString('en-US');

interface SumChartProps {
  dataCount?: {
    shotCount?: number;
    visitCount?: number;
    uniqueCount?: number;
  };
}

const SumChart: React.FC<SumChartProps> = ({ dataCount }) => {
  const theme = useTheme();

  const data = [
    { title: ja.dashboard.shots, value: dataCount?.shotCount ?? 0 },
    { title: ja.dashboard.visits, value: dataCount?.visitCount ?? 0 },
    { title: ja.dashboard.unique, value: dataCount?.uniqueCount ?? 0 },
  ];

  return (
    <Stack
      sx={{
        gap: '10px',
        '& *': {
          fontWeight: '700 !important',
        },
      }}
    >
      {data.map((item, index) => (
        <Stack
          key={`sum-chart-${index}`}
          flexDirection='row'
          justifyContent='space-between'
          sx={{
            borderRadius: '8px',
            borderLeft: '4px solid #3BBCD4',
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 4px 4px 0px #00000040',
            px: '10px',
          }}
        >
          <Typography>{item.title}</Typography>
          <Typography color={theme.palette.primary.main}>
            {formatNumber(item.value)}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default memo(SumChart);
